import { getI18NInstance, toI18nextLanguage } from './instance'
import { getSessionLocale } from '@services/session'

const loadedNamespaces = new Set<string>()

function namespaceCacheKey(namespace: string, locale: string): string {
  return `${namespace}::${locale}`
}

/**
 * Ensures an i18next namespace is loaded for the current (or given) locale.
 * Safe to call repeatedly — dedupes in-flight loads.
 */
export async function ensureI18nNamespace(
  namespace: string,
  locale?: string,
): Promise<void> {
  const i18n = getI18NInstance(true)
  const resolvedLocale = toI18nextLanguage(locale ?? getSessionLocale())
  const cacheKey = namespaceCacheKey(namespace, resolvedLocale)

  if (loadedNamespaces.has(cacheKey)) {
    return
  }

  if (i18n.language !== resolvedLocale) {
    await i18n.changeLanguage(resolvedLocale)
  }

  await i18n.loadNamespaces(namespace)
  loadedNamespaces.add(cacheKey)
}

/** Clears the in-memory namespace cache (e.g. on locale change). */
export function clearI18nNamespaceCache(): void {
  loadedNamespaces.clear()
}
